import {type SoftDeletable, type TimeStamped} from "./common";
import {type CompanyMemberRole} from "./companyMember";

export enum UserInvitationStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    CANCELLED = "CANCELLED",
}

export interface UserInvitation extends TimeStamped, SoftDeletable {
    id: string;
    companyId: string;
    userId?: string;
    userEmail: string;
    role: CompanyMemberRole;
    status: UserInvitationStatus;
}

/**
 * UserInvitationEx provides additional information about invited user and company inviting a user
 * userName can be null if user is not registered yet
 */
export interface UserInvitationEx extends UserInvitation {
    companyName: string;
    userName: string | null;
}
